var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCwVoiceCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.76 23.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#21a82e;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.01,
    cy: 11.82,
    r: 11.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.71,8.17A4.18,4.18,0,0,0,8.29,5.09C8.29,5,8.17,5,8.05,5,5.57,5.45,5.21,6.84,5.21,6.9v.25c2.9,9.07,9,10.76,11,11.3.18.06.3.06.36.12s.24,0,.37,0a3.72,3.72,0,0,0,1.87-2.9.54.54,0,0,0-.06-.3,4.46,4.46,0,0,0-2.9-2,.41.41,0,0,0-.43.12,6.07,6.07,0,0,1-2,1.21,8.5,8.5,0,0,1-4.17-4.23,4.25,4.25,0,0,1,1.27-1.93C10.71,8.42,10.77,8.3,10.71,8.17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwVoiceCall);
export default __webpack_public_path__ + "static/media/cw-voice-call.321a2165e6b26c4b2db682de27896a72.svg";
export { ForwardRef as ReactComponent };